import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/checkout';
type CtaButtonSize = 'md' | 'lg';
type CtaButtonProps = {
  label: string;
  note?: string;
  size?: CtaButtonSize;
  className?: string;
};
export function CtaButton({
  label,
  note,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const pad = size === 'lg' ? 'px-5 py-4 text-base sm:text-lg sm:px-8 sm:py-5' : 'px-5 py-3.5 text-sm sm:text-base sm:px-7 sm:py-4';
  return <div className={`w-full ${className}`} data-id="element-26" data-mp="llqravhl99ws">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-xl bg-accent text-center font-display uppercase leading-tight tracking-wide text-ink-950 shadow-[0_10px_30px_-12px_rgba(255,193,7,0.65)] transition-[transform,background-color] duration-150 ease-out hover:bg-accent-soft active:scale-[0.985] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${pad}`} data-id="element-27" data-mp="lkpd4i5a07au">
        <span className="text-balance" data-id="element-28" data-mp="35y7kkjxrj71m">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-29" data-mp="35zinyinaqcs7" />
      </a>
      {note ? <p className="mt-2.5 text-center text-[11px] font-medium uppercase tracking-wider text-white/45 sm:text-xs" data-id="element-30" data-mp="3f070ta0ye73i">
          {note}
        </p> : null}
    </div>;
}